import 'alpinejs'
import 'focus-visible'

// Global cookie functions (used by cookie banner).
window.setCookie = function (name, value, days) {
    let expires = ''
    if (days) {
        const date = new Date()
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
        expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/'
}

window.eraseCookie = function (name) {
    document.cookie = name + '=; Max-Age=-99999999;'
}

window.getCookie = function (name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

// Global get CSRF token function (used by forms).
window.getToken = async () => {
    const token = await fetch('/!/DynamicToken/refresh')
        .then((res) => res.json())
        .then((data) => {
            return data.csrf_token
        })
        .catch(function (error) {
            this.error = 'Something went wrong. Please try again later.'
        })

    return token
}

/* ~~~~~~~~~~~~~~~~~~~~~~
~~~ TYPEWRITER EFFECT ~~~
~~~~~~~~~~~~~~~~~~~~~~ */
function typeString(el, sentence, speed) {
    let index = 0;
    let timer = setInterval(() => {
        let char = sentence.charAt(index);
        if (char === '<') {
            index = sentence.indexOf('>', index);
        }
        document.querySelector(el).innerHTML = sentence.substr(0, index);
        if (index++ === sentence.length) {
            clearInterval(timer);
        }
    }, speed);
}

const sp1 = document.querySelector('#uc');
const sp1ID = document.querySelector('#uc').id;
const sp1Text = sp1.dataset.typer;
setTimeout(() => {
    // typeSEO(`#${sp1ID}`, color);
    typeString(`#${sp1ID}`, `${sp1Text}`, 50);
}, 300);

const sp2 = document.querySelector('#uc_sub');
const sp2ID = document.querySelector('#uc_sub').id;
const sp2Text = sp2.dataset.typer;
setTimeout(() => {
    // typeSEO(`#${sp1ID}`, color);
    typeString(`#${sp2ID}`, `${sp2Text}`, 50);
}, 2400);


setTimeout(() => {
    // typeSEO(`#${sp1ID}`, color);
    document.getElementById('main_text').style.display = 'block';
    // typeString(`#${sp3ID}`, `${sp3Text}`, 50);
}, 5000);
